import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import version from './config/version';

Sentry.init({
  dsn: 'https://1955aad6723031d94cf3535bf1c68a1d@sentry-next.pinchos.se/8',
  environment: process.env.NODE_ENV,
  release: version,
});

ReactDOM.render(<App />, document.getElementById('root'));
unregister();
